import React from "react";
import { Input, Label } from "reactstrap";
import NumberFormat from "react-number-format";
import useCurrentDealStore from "stores/DealStore";
import { DealStatus, LoanPeriod } from "constants/Constants";
import shallow from "zustand/shallow";
import useCurrentLeaseStore from "../../../../stores/LeaseStore";
import { moneyFactorFromApr } from "../../helperFunctions/LeaseFunctions";

const LeaseAprInput = () => {
	const { apr, lastEditedRate, leasePeriod, editField } = useCurrentLeaseStore(
		(state) => ({ ...state }),
		shallow
	);
	const { type } = useCurrentDealStore(
		(state) => ({
			type: state.deal.type,
		}),
		shallow
	);
	console.log("leasePeriod", leasePeriod);
	const periodPerYear = LoanPeriod[leasePeriod].term;
	const handleAprChange = (values) => {
		if (lastEditedRate !== "APR") return;
		const aprPercent = Number(values.floatValue / 100) || 0;
		const mf = moneyFactorFromApr(aprPercent, periodPerYear); // APR% -> MF
		editField("apr", aprPercent);
		editField("moneyFactor", Number(mf.toFixed(8))); // keep MF in sync
		console.log("handleAprChange", Number(mf.toFixed(8)));
	};

	return (
		<>
			<Label>APR (%) </Label>
			<NumberFormat
				name="leaseAPR"
				value={apr * 100}
				decimalScale={4}
				wholeRow={true}
				fixedDecimalScale={true}
				onFocus={() => editField("lastEditedRate", "APR")}
				isNumericString={true}
				readOnly={type !== DealStatus.PENDING}
				customInput={Input}
				onValueChange={handleAprChange}
			/>
		</>
	);
};

export default LeaseAprInput;
